import { render, staticRenderFns } from "./FormInputGroupCheckboxRadio.vue?vue&type=template&id=509d36b8&"
import script from "./FormInputGroupCheckboxRadio.vue?vue&type=script&lang=js&"
export * from "./FormInputGroupCheckboxRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports